/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClockInStatus } from '../models/ClockInStatus';
import type { SuccessResponse } from '../models/SuccessResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TailorService {
    /**
     * Clock In Status
     * @param accessCode
     * @returns ClockInStatus Successful Response
     * @throws ApiError
     */
    public static clockInStatusTailorClockInStatusGet(
        accessCode: string,
    ): CancelablePromise<ClockInStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tailor/clock_in_status',
            query: {
                'access_code': accessCode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clock In
     * @param tailorId
     * @returns SuccessResponse Successful Response
     * @throws ApiError
     */
    public static clockInTailorClockInPost(
        tailorId: string,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tailor/clock_in',
            query: {
                'tailor_id': tailorId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clock Out
     * @param tailorId
     * @param lunchTaken
     * @param clockOutTime
     * @returns SuccessResponse Successful Response
     * @throws ApiError
     */
    public static clockOutTailorClockOutPost(
        tailorId: string,
        lunchTaken: boolean = true,
        clockOutTime?: string,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tailor/clock_out',
            query: {
                'tailor_id': tailorId,
                'lunch_taken': lunchTaken,
                'clock_out_time': clockOutTime,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
